export default class GetSingleAccountTransactionsRequest {
    fromDate: string;
    toDate: string;
    accountId: string;
    accountName: string;
    walletId: string;
}